import _defineProperty from '@babel/runtime/helpers/defineProperty';
import styled, { css } from 'styled-components';
import { siteThemes, theme, isGlobetrotter } from '../../utils/theming.js';
import mq from '../../utils/mediaQueries.js';

var DEFAULT = siteThemes.DEFAULT,
  GLOBETROTTER = siteThemes.GLOBETROTTER;
var dayBorderRadius = theme('site', _defineProperty(_defineProperty({}, DEFAULT, '100%'), GLOBETROTTER, '0'));
var inRangeBackgroundColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, 'var(--color-core-500)'), GLOBETROTTER, 'var(--color-quartz-200)'));
var inRangeTextColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, 'var(--color-black)'), GLOBETROTTER, 'var(--color-black)'));
var frameColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, 'var(--color-grey-25)'), GLOBETROTTER, 'transparent'));
var monthTitleFontWeight = theme('site', _defineProperty(_defineProperty({}, DEFAULT, 700), GLOBETROTTER, 400));
var labelColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, 'var(--color-teal-800)'), GLOBETROTTER, 'var(--color-quartz-550)'));
var recommendedIndicatorColor = theme('site', _defineProperty(_defineProperty({}, DEFAULT, 'var(--color-rouge-500)'), GLOBETROTTER, 'var(--color-earth)'));
var Cell = styled.div.withConfig({
  displayName: "style__Cell",
  componentId: "sc-k1ow7y-0"
})(["flex-basis:100%;margin:0 -1px 0;text-align:center;"]);
var WeekNrCell = styled(Cell).withConfig({
  displayName: "style__WeekNrCell",
  componentId: "sc-k1ow7y-1"
})(["flex:0 0 20px;font-size:12px;color:", ";display:flex;justify-content:center;align-items:center;background-color:", ";margin-right:8px;", ""], labelColor, frameColor, function (_ref) {
  var $datePickerHasOffers = _ref.$datePickerHasOffers;
  return $datePickerHasOffers && css(["align-items:flex-start;padding-top:13px;"]);
});
var Day = styled.button.withConfig({
  displayName: "style__Day",
  componentId: "sc-k1ow7y-2"
})(["height:36px;width:36px;border-radius:", ";font-size:16px;position:relative;z-index:1;color:var(--color-black);", " ", " &:focus-visible{border-radius:", ";}"], dayBorderRadius, function (_ref2) {
  var $isDisabled = _ref2.$isDisabled;
  return $isDisabled && css(["color:var(--color-grey-400);pointer-events:none;"]);
}, function (_ref3) {
  var $datePickerHasSelectedMonths = _ref3.$datePickerHasSelectedMonths,
    $inRange = _ref3.$inRange,
    $isRangeEnd = _ref3.$isRangeEnd,
    $isRangeStart = _ref3.$isRangeStart,
    $isSelected = _ref3.$isSelected,
    $useDynamicRangeSelect = _ref3.$useDynamicRangeSelect;
  return !$datePickerHasSelectedMonths && css(["", " ", " ", ""], $inRange && css(["background-color:", ";color:", ";"], inRangeBackgroundColor, inRangeTextColor), ($isSelected || $isRangeEnd || $isRangeStart) && css(["background-color:var(--color-cta-button-primary);color:var(--color-white);"]), ($isRangeEnd || $isRangeStart) && !$useDynamicRangeSelect && css(["background-color:", ";color:var(--color-black);"], inRangeBackgroundColor));
}, dayBorderRadius);
var DayCell = styled(Cell).withConfig({
  displayName: "style__DayCell",
  componentId: "sc-k1ow7y-3"
})(["height:36px;margin-bottom:2px;cursor:pointer;position:relative;", " ", " &:hover,&:focus-within{", "{background-color:", ";", "}}", " ", " svg{margin:3px auto 0;display:block;}"], function (_ref4) {
  var $datePickerHasOffers = _ref4.$datePickerHasOffers;
  return $datePickerHasOffers && css(["height:65px;"]);
}, function (_ref5) {
  var $isDisabled = _ref5.$isDisabled;
  return $isDisabled && css(["pointer-events:none;"]);
}, Day, function (_ref6) {
  var $dynamicRangeInProgress = _ref6.$dynamicRangeInProgress,
    $isDisabled = _ref6.$isDisabled;
  if ($dynamicRangeInProgress) return css(["font-variant(--color-white)"]);
  if ($isDisabled) return css(["unset"]);
  return css(["var(--color-grey-300)"]);
}, function (_ref7) {
  var $datePickerHasSelectedMonths = _ref7.$datePickerHasSelectedMonths,
    $inRange = _ref7.$inRange,
    $isSelected = _ref7.$isSelected;
  return ($inRange || $isSelected) && !$datePickerHasSelectedMonths && css(["background-color:var(--color-cta-button-primary);color:var(--color-white);"]);
}, function (_ref8) {
  var $monthIsSelected = _ref8.$monthIsSelected;
  return $monthIsSelected && css(["background-color:var(--color-grey-100);"]);
}, function (_ref9) {
  var $datePickerHasSelectedMonths = _ref9.$datePickerHasSelectedMonths,
    $inRange = _ref9.$inRange,
    $isRangeEnd = _ref9.$isRangeEnd,
    $isRangeStart = _ref9.$isRangeStart;
  return !$datePickerHasSelectedMonths && css(["", ""], $inRange && css(["background-color:", ";&:last-child{background:linear-gradient( 90deg,", " 50%,transparent 50% );}&:nth-child(2){background:linear-gradient( 90deg,transparent 50%,", " 50% );}", " ", ""], inRangeBackgroundColor, inRangeBackgroundColor, inRangeBackgroundColor, $isRangeStart && css(["background:linear-gradient( 90deg,transparent 50%,", " 50% );&:last-child{background:transparent;}"], inRangeBackgroundColor), $isRangeEnd && css(["background:linear-gradient( 90deg,", " 50%,transparent 50% );&:nth-child(2){background:transparent;}"], inRangeBackgroundColor)));
});
var OfferContainer = styled.div.withConfig({
  displayName: "style__OfferContainer",
  componentId: "sc-k1ow7y-4"
})(["background-color:var(--color-white);position:relative;z-index:3;padding-top:3px;"]);
var DayOffer = styled.div.withConfig({
  displayName: "style__DayOffer",
  componentId: "sc-k1ow7y-5"
})(["font-size:12px;color:", ";font-family:var(--font-family-headline-light);"], function (props) {
  return props.isCheapest ? css(["var(--color-rouge-500)"]) : labelColor;
});
var RecommendedIndicator = styled.div.withConfig({
  displayName: "style__RecommendedIndicator",
  componentId: "sc-k1ow7y-6"
})(["position:absolute;font-size:20px;left:calc(50% - 3px);bottom:-4px;color:", ";z-index:2;", ""], recommendedIndicatorColor, isGlobetrotter(css(["bottom:-8px;"])));
var BlankCell = styled(Cell).withConfig({
  displayName: "style__BlankCell",
  componentId: "sc-k1ow7y-7"
})(["pointer-events:none;"]);
var MonthHeader = styled.div.withConfig({
  displayName: "style__MonthHeader",
  componentId: "sc-k1ow7y-8"
})(["display:flex;justify-content:center;flex-wrap:nowrap;line-height:20px;", "{border-bottom:1px solid var(--color-grey-25);}", "{border:0;}"], Cell, WeekNrCell);
var MonthHeaderMobileSticky = styled(MonthHeader).withConfig({
  displayName: "style__MonthHeaderMobileSticky",
  componentId: "sc-k1ow7y-9"
})(["", " ", ""], mq.sMax(css(["position:sticky;top:0;z-index:2;background:var(--color-white);"])), mq.s(css(["display:none;"])));
var Week = styled.div.withConfig({
  displayName: "style__Week",
  componentId: "sc-k1ow7y-10"
})(["display:flex;justify-content:center;flex-wrap:nowrap;"]);
var DayNameCell = styled(Cell).withConfig({
  displayName: "style__DayNameCell",
  componentId: "sc-k1ow7y-11"
})(["font-size:12px;white-space:nowrap;color:", ";margin-bottom:2px;"], labelColor);
var MonthFooter = styled.div.withConfig({
  displayName: "style__MonthFooter",
  componentId: "sc-k1ow7y-12"
})(["display:block;flex:0 1 auto;padding:20px 8px 4px 20px;", ""], mq.s(css(["padding:14px 8px 4px;"])));

/** ******** DATE PICKER ********* */

var DatePickerWrapper = styled.div.withConfig({
  displayName: "style__DatePickerWrapper",
  componentId: "sc-k1ow7y-13"
})(["width:100%;position:relative;display:flex;flex-direction:column;", ""], mq.s(css(["overflow:hidden;"])));
var DatePickerInnerWrapper = styled.div.withConfig({
  displayName: "style__DatePickerInnerWrapper",
  componentId: "sc-k1ow7y-14"
})(["", ""], mq.s(css(["margin:0 -5px;"])));
var DatePickerHeader = styled.div.withConfig({
  displayName: "style__DatePickerHeader",
  componentId: "sc-k1ow7y-15"
})(["flex:0 1 0%;", "{display:flex;position:sticky;}", ""], MonthHeader, mq.s(css(["", "{display:none;position:static;}"], MonthHeader)));
var DatePickerBody = styled.div.withConfig({
  displayName: "style__DatePickerBody",
  componentId: "sc-k1ow7y-16"
})(["flex:1 1 auto;"]);
var DatePickerNav = styled.button.withConfig({
  displayName: "style__DatePickerNav",
  componentId: "sc-k1ow7y-17"
})(["display:none;position:absolute;top:20px;z-index:1;&.sg-datepicker__nav-prev:before,&.sg-datepicker__nav-next:before{content:'';position:absolute;width:50px;height:50px;cursor:pointer;}&.sg-datepicker__nav-prev{left:23px;&:before{top:-15px;left:-15px;}}&.sg-datepicker__nav-next{right:23px;&:before{top:-15px;right:-15px;}}", ""], mq.s(css(["", ""], function (props) {
  return !props.hidden && css(["display:block;"]);
})));
var DatePickerMonths = styled.div.withConfig({
  displayName: "style__DatePickerMonths",
  componentId: "sc-k1ow7y-18"
})(["position:relative;transition:transform 0.3s ease;height:auto;", "{margin-bottom:38px;}", ""], MonthFooter, mq.s(css(["display:flex;flex-direction:row;width:auto;white-space:nowrap;", "{margin-bottom:0;}"], MonthFooter)));
styled.div.withConfig({
  displayName: "style__DatePickerMonth",
  componentId: "sc-k1ow7y-19"
})(["margin-bottom:38px;"]);
var MonthWrapper = styled.div.withConfig({
  displayName: "style__MonthWrapper",
  componentId: "sc-k1ow7y-20"
})(["display:flex;flex-direction:column;width:100%;overflow-x:hidden;", " ", " ", ""], isGlobetrotter(css(["", ""], mq.s(css(["&:not(:last-child){border-right:1px solid var(--color-quartz-200);}"])))), mq.s(css(["flex:1 0 50%;max-width:50%;padding:8px;display:inline-flex;border-left:solid 5px var(--color-white);border-right:solid 5px var(--color-white);background-color:", ";", ""], frameColor, function (props) {
  return props.$nrOfMonthsDisplayedDesktop === 3 && css(["flex:1 0 33.33%;max-width:33.33%;"]);
})), mq.sMax(css(["", "{display:none;}"], MonthHeader)));
var MonthTitle = styled.div.withConfig({
  displayName: "style__MonthTitle",
  componentId: "sc-k1ow7y-21"
})(["text-transform:capitalize;text-align:center;margin:10px 0 20px;font-size:18px;font-family:var(--font-family-body);font-weight:", ";flex:0 1 0%;"], monthTitleFontWeight);
var Month = styled.div.withConfig({
  displayName: "style__Month",
  componentId: "sc-k1ow7y-22"
})(["flex:1 1 auto;background-color:var(--color-white);", ""], mq.s(css(["padding:8px;"])));

export { BlankCell, Cell, DatePickerBody, DatePickerHeader, DatePickerInnerWrapper, DatePickerMonths, DatePickerNav, DatePickerWrapper, Day, DayCell, DayNameCell, DayOffer, Month, MonthFooter, MonthHeader, MonthHeaderMobileSticky, MonthTitle, MonthWrapper, OfferContainer, RecommendedIndicator, Week, WeekNrCell };
//# sourceMappingURL=style.js.map
